import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import $ from 'jquery';
import Vas from '../../../Vas';
import '../../../css/CustomerContractDetails.css';
import { EditFormButton,TextField, AutocompleteField,SelectField,DateField,MessageBox } from 'component-lib';
import { TranslateGender,DateTimeHelper } from 'utils-lib';
import { RequestAjaxClass, AdditionalAddressesModel,StreetsModel,GenderModel } from 'models-lib';

var moment = require('moment');
moment().format();

class CustomerAddressDetails extends Component
{
    constructor(props)
    {
        super(props);
        this.state = {};
        this.state.Edit = false;
        this.Request = new RequestAjaxClass((error)=>{Vas.ErrorHandling(error);},null);

        this.AdditionalAddressesModel = new AdditionalAddressesModel([this],null,this.Request);
        this.StreetsModel = new StreetsModel([this],null,this.Request);

        this.reference =  props.reference;

        // eslint-disable-next-line no-unused-expressions
        this.Request2 = new RequestAjaxClass((error)=>{this.props.ErrorHandling ? this.props.ErrorHandling(error) : '';},null);
        this.GenderModel = new GenderModel([this], null, this.Request2);

        this.Request2.setAuth(false);
        this.Request2.setApiKey(Vas.ApiKey);
        this.Request2.setApiUrl(Vas.ApiUrl);

        this.GenderModel.GetGender();

        this.IconConfig = Vas.Config.ShowIconsOrButtons;
    }

    componentDidMount(){
      this.Request.setAuth(false);
      this.Request.setApiKey(Vas.ApiKey);
      this.Request.setApiUrl(Vas.ApiUrl);

      localStorage.setItem("Address",JSON.stringify(this.props.data[0]));
      this.AdditionalAddressesModel.Address = this.props.data[0];

      let reqFields = [this.refs.name, this.refs.firstName,this.refs.zip, this.refs.city,this.refs.houseNumber, this.refs.street];
     
      if (this.AdditionalAddressesModel.Address.Salutation === "Firma" || this.AdditionalAddressesModel.Address.Salutation === "Schule") {
        reqFields = [this.refs.name ,this.refs.zip, this.refs.city,this.refs.houseNumber, this.refs.street];
      } 
      
      this.setState({ requiredFields:reqFields, 
        requiredSelectField:[this.refs.gender],
      });

      this.load(this.AdditionalAddressesModel.Address);
    }

    componentDidUpdate()
    {
      if (this.state.Edit === false)
      {
          this.setFieldStates(false);
      }
      else
      {
          this.setFieldStates(true);
      }

      this.LogoClick();

      this.FontSizeClick();
    }

    Update(observer)
    {
      let me =this;
      
        me.setState({},()=>{
          if(observer === "AddressPUT"){
              me.reference.load();
              let result = me.AdditionalAddressesModel.Address;
              localStorage.setItem("Address",JSON.stringify(result));
              me.Cancel(result);
          }
          else if(observer === "Streets"){            
            me.refs.street.setState({ Data: me.StreetsModel.Streets, Icon :'',placeholder:'' });
            me.setState({ oldZip: me.StreetsModel.zip, oldCity: me.StreetsModel.city });
          }
          else if(observer === "Gender"){
            let genderSelection = []
        
            if(this.GenderModel.Gender.length > 0){
  
              let genderArray = this.GenderModel.Gender;
  
              if(genderArray.length === 2) {
                genderSelection = [{ Key: genderArray[0], Display: Vas.Resources.Labels["Male"] },{ Key: genderArray[1], Display: Vas.Resources.Labels["Female"] }];
              } else if(genderArray.length === 3){
                genderSelection = [{ Key: genderArray[0], Display: Vas.Resources.Labels["Male"] },{ Key: genderArray[1], Display: Vas.Resources.Labels["Female"] },{ Key: genderArray[2], Display: 'divers' }];
              }
            }
            this.setState({GenderValues : genderSelection});
            this.refs.gender.setState({Data:genderSelection});
          }
        });
    }

    load(address){
      if(document.getElementById("Salutation")){
        document.getElementById("Salutation").onselectstart = function(){return false;};
        document.getElementById("Salutation").onmousedown = function(){return false;};
      }
      document.onselectstart = new Function ("return false");

      this.loadAdress(address);
    }

    loadAdress(adress){
      this.setState({},()=>{
        let me = this;
        
        if (me.refs){

          document.getElementById('Salutation').value = adress.Salutation;
          document.getElementById('Name1').value = adress.Name1;
          document.getElementById('Name2').value = adress.Name2;
          document.getElementById('Gender').value = adress.Gender;
          document.getElementById('DateOfBirth').value = DateTimeHelper.FormatToShortDateString(DateTimeHelper.StringToDate(adress.DateOfBirth,true,localStorage.getItem('vas_language')));
          document.getElementById('Zip').value = adress.Zip;
          document.getElementById('City').value = adress.City;
          document.getElementById('Street').value = adress.Street;
          document.getElementById('AddressAddition').value = adress.Name3;
          document.getElementById('HouseNumber').value = adress.HouseNumber;
          document.getElementById('HouseNumberAddition').value = adress.HouseNumberAddition;
          document.getElementById('Email').value = adress.Email;
          document.getElementById("Phone").value = adress.Phone;

        }
        $("#LoadingIcon").removeClass().addClass('hide');
      });
    }

    setFieldStates(value){
      if(value !== undefined && value !== null){
        if(value === true || value === false){
          let me = this;
          if(me.refs.adressAddition){
            me.refs.adressAddition.setState({ editable:value });
          }
          if(me.refs.zip){
            me.refs.zip.setState({ editable:value });
          }
          if(me.refs.city){
            me.refs.city.setState({ editable:value });
          }
          if(me.refs.houseNumber){
            me.refs.houseNumber.setState({ editable:value });
          }
          if(me.refs.street){
            me.refs.street.setState({ editable:value });
          }
          if(me.refs.houseNumberAddition){
            me.refs.houseNumberAddition.setState({ editable:value });
          }
          if(me.refs.phone){
            me.refs.phone.setState({ editable:value });
          }
          if(me.refs.email){
            me.refs.email.setState({ editable:value });
          }
          if(me.refs.gender){
            me.refs.gender.setState({ Placeholder:me.state.Gender });
          }
          
          if(document.getElementById("Name1")){
            document.getElementById("Name1").onselectstart = function(){return value;};
            document.getElementById("Name1").onmousedown = function(){return value;};
          }
          if(document.getElementById("Name1")){
            document.getElementById("Name2").onselectstart = function(){return value;};
            document.getElementById("Name2").onmousedown = function(){return value;};
          }
          if(document.getElementById("Gender")){
            document.getElementById("Gender").onselectstart = function(){return value;};
            document.getElementById("Gender").onmousedown = function(){return value;};
          }
          if(document.getElementById("DateOfBirth")){
            document.getElementById("DateOfBirth").onselectstart = function(){return value;};
            document.getElementById("DateOfBirth").onmousedown = function(){return value;};
          }
          if(document.getElementById("AddressAddition")){
            document.getElementById("AddressAddition").onselectstart = function(){return value;};
            document.getElementById("AddressAddition").onmousedown = function(){return value;};
          }
          if(document.getElementById("Zip")){
            document.getElementById("Zip").onselectstart = function(){return value;};
            document.getElementById("Zip").onmousedown = function(){return value;};
          }
          if(document.getElementById("City")){
            document.getElementById("City").onselectstart = function(){return value;};
            document.getElementById("City").onmousedown = function(){return value;};
          }
          if(document.getElementById("Street")){
            document.getElementById("Street").onselectstart = function(){return value;};
            document.getElementById("Street").onmousedown = function(){return value;};
          }
          if(document.getElementById("HouseNumber")){
            document.getElementById("HouseNumber").onselectstart = function(){return value;};
            document.getElementById("HouseNumber").onmousedown = function(){return value;};
          }
          if(document.getElementById("HouseNumberAddition")){
            document.getElementById("HouseNumberAddition").onselectstart = function(){return value;};
            document.getElementById("HouseNumberAddition").onmousedown = function(){return value;};
          }
          if(document.getElementById("Phone")){
            document.getElementById("Phone").onselectstart = function(){return value;};
            document.getElementById("Phone").onmousedown = function(){return value;};
          }
          if(document.getElementById("Email")){
            document.getElementById("Email").onselectstart = function(){return value;};
            document.getElementById("Email").onmousedown = function(){return value;};
          }
        }
      }
    }

    Cancel(){
      this.setState({oldZip:'',oldCity:''},()=>{
        this.load(JSON.parse(localStorage.getItem("Address")));
      });
    }

    getStreets()
    {
      let me = this;
      me.refs.street.setState({ Icon:"Loop" });

      if ((me.AdditionalAddressesModel.Address.Zip !== me.state.oldZip)||(me.AdditionalAddressesModel.Address.City !== me.state.oldCity)){
        me.refs.street.setState({ Data: [], Icon : '' });
        document.getElementById("Street").value = '';
      }

      if (me.AdditionalAddressesModel.Address.City || me.AdditionalAddressesModel.Address.Zip){
        let city = '';
        let zip = '';
        if (me.AdditionalAddressesModel.Address.City){
          city=me.AdditionalAddressesModel.Address.City;
        } else {
          city = document.getElementById("City").placeholder;
        }
        if (me.AdditionalAddressesModel.Address.Zip){
          zip=me.AdditionalAddressesModel.Address.Zip;
        } else {
          zip = document.getElementById("Zip").placeholder;
        }

        this.StreetsModel.GetStreets(city,zip);
      }
    };

    checkFields(){
        let count;
        if (this.state.requiredFields  && this.state.requiredSelectField){
          count = this.state.requiredFields.length +  this.state.requiredSelectField.length;
          let filled = 0; //Anzahl der korrekt gefüllten Feldern 
          for (let i = 0;i < this.state.requiredFields.length;i++){
            if (this.state.requiredFields[i]){
                if (document.getElementById(this.state.requiredFields[i].props.Id).value.length > 0 || document.getElementById(this.state.requiredFields[i].props.Id).placeholder.length > 0){
                  filled++;
                }
            }
          }

          for (let k = 0; k < this.state.requiredSelectField.length;k++){
            if (this.state.requiredSelectField[k]){
              if (document.getElementById(this.state.requiredSelectField[k].props.Id).selectedIndex > 0){
                    filled++;
                }
            }
          }
          if (filled < count){
              return false;
          } else {
            return true;
          }
        }
    }

    CustomerUpdate()
    {   
      if (this.checkFields()=== true){
        this.PostAddress();
        this.setState({oldCity:'',oldZip:''});
      } else {

        ReactDOM.render(<MessageBox
          Message={Vas.Resources.Labels["NotAllFields"]}
          Title={Vas.Resources.Titles["Note"]}
        />,document.getElementById('messageContainer'));
        this.load(JSON.parse(localStorage.getItem("Address")));
      }
    }

    PostAddress(){
      alert("Hallo");
      this.AdditionalAddressesModel.Address.Street = $("#Street").val();
      this.AdditionalAddressesModel.Address.HouseNumber = $("#HouseNumber").val();

      if (this.AdditionalAddressesModel.Address.Name1.length > 0 && this.AdditionalAddressesModel.Address.Name2.length > 0 && DateTimeHelper.StringToDate(this.AdditionalAddressesModel.Address.DateOfBirth,true, localStorage.getItem('vas_language')).isValid() === true){
        $("#LoadingIcon").removeClass().addClass('loaderSmall');
        this.Request.setErrorHandler(()=>{
          this.load(JSON.parse(localStorage.getItem("Address")));
        });

        this.AdditionalAddressesModel.Address.Gender = $('#Gender').val();

        let sal = '';

        switch (localStorage.getItem("vas_language")) {
          case 'de':
              if ($('#Gender').val() === "weiblich") {
                  sal = "Frau";
              } else if($('#Gender').val() === "männlich"){
                  sal = "Herr";
              }
              break;
          case 'en':
              if ($('#Gender').val() === "female") {
                  sal = "Mrs";
              } else if($('#Gender').val() === "male"){
                  sal = "Mr";
              }
              break;
          default:
              break;
        }

        this.AdditionalAddressesModel.Address.Salutation = sal;

        console.log(this.AdditionalAddressesModel);

        this.AdditionalAddressesModel.UpdateAdditionalAddress();
      } else {
        
      }
    }

    LogoClick(){

      var kontrastNumber = localStorage.getItem('Kontrast');

      if(kontrastNumber == "true"){
        $('.extendedButton').attr('style', 'background-color: #1d5c87; width: 100px;');
        $('#btoChoose').attr('style', 'background-color: #1d5c87; width: 100px;');
        $('.customerDataContainerEditButtonNoIconsAdditionalAddressEdit > div:nth-child(1) > div:nth-child(1) > table:nth-child(1) > tbody:nth-child(1) > tr:nth-child(1) > td:nth-child(2) > div:nth-child(1) > button:nth-child(1)').attr('style', 'background-color: #1d5c87; width: 100px;');

        $('.datefieldDisabled, .textfieldDisabled, .emailfieldDisabled, .numfieldDisabled').attr("style", "background-color: white !important; border-bottom: 1px dotted #1d5c87;");
      }
    }

    FontSizeClick(){
      var schriftgröße = localStorage.getItem('Schriftgröße');
      var kontrastNumber = localStorage.getItem('Kontrast');
  
      //Schriftgröße bei Klick in 2er Schritten erhöhen
        if(schriftgröße != null){
              switch(schriftgröße){               
                case "0":
                  if(kontrastNumber == "true"){
                    $('#Gender').attr("style", "font-size: 19px; background-color: white !important; border-bottom: 1px dotted #1d5c87;");
                    $('#Zip').attr("style", "font-size: 19px; background-color: white !important; border-bottom: 1px dotted #1d5c87;");
                    $('#City').attr("style", "font-size: 19px; background-color: white !important; border-bottom: 1px dotted #1d5c87;");
                    $('#Street').attr("style", "font-size: 19px; background-color: white !important; border-bottom: 1px dotted #1d5c87;");
                    $('#HouseNumber').attr("style", "font-size: 19px; background-color: white !important; border-bottom: 1px dotted #1d5c87;");
                    $('#HouseNumberAddition').attr("style", "font-size: 19px; background-color: white !important; border-bottom: 1px dotted #1d5c87;");
                  } else{
                    $('#Gender').attr("style", "font-size: 19px;");
                    $('#Zip').attr("style", "font-size: 19px;");
                    $('#City').attr("style", "font-size: 19px;");
                    $('#Street').attr("style", "font-size: 19px;");
                    $('#HouseNumber').attr("style", "font-size: 19px;");
                    $('#HouseNumberAddition').attr("style", "font-size: 19px;");
                  }

                  $('#btoChoose').removeClass("btoChooseWidth100_40").addClass("btoChooseWidth100_40").removeClass("Schriftgröße_18").addClass("Schriftgröße_19");
                  $('.customerDataContainerEditButtonNoIconsAdditionalAddressEdit > div:nth-child(1) > div:nth-child(1) > table:nth-child(1) > tbody:nth-child(1) > tr:nth-child(1) > td:nth-child(2) > div:nth-child(1) > button:nth-child(1)').removeClass("Schriftgröße_18").addClass("Schriftgröße_19");
                break;
                case "1":
                  if(kontrastNumber == "true"){
                    $('#Gender').attr("style", "font-size: 14px; background-color: white !important; border-bottom: 1px dotted #1d5c87;");
                    $('#Zip').attr("style", "font-size: 14px; background-color: white !important; border-bottom: 1px dotted #1d5c87;");
                    $('#City').attr("style", "font-size: 14px; background-color: white !important; border-bottom: 1px dotted #1d5c87;");
                    $('#Street').attr("style", "font-size: 14px; background-color: white !important; border-bottom: 1px dotted #1d5c87;");
                    $('#HouseNumber').attr("style", "font-size: 14px; background-color: white !important; border-bottom: 1px dotted #1d5c87;");
                    $('#HouseNumberAddition').attr("style", "font-size: 14px; background-color: white !important; border-bottom: 1px dotted #1d5c87;");
                  } else{
                    $('#Gender').attr("style", "font-size: 14px;");
                    $('#Zip').attr("style", "font-size: 14px;");
                    $('#City').attr("style", "font-size: 14px;");
                    $('#Street').attr("style", "font-size: 14px;");
                    $('#HouseNumber').attr("style", "font-size: 14px;");
                    $('#HouseNumberAddition').attr("style", "font-size: 14px;");
                  }

                  $('#btoChoose').removeClass("btoChooseWidth100_40").addClass("btoChooseWidth100_0").removeClass("Schriftgröße_19").addClass("Schriftgröße_14");
                  $('.customerDataContainerEditButtonNoIconsAdditionalAddressEdit > div:nth-child(1) > div:nth-child(1) > table:nth-child(1) > tbody:nth-child(1) > tr:nth-child(1) > td:nth-child(2) > div:nth-child(1) > button:nth-child(1)').removeClass("Schriftgröße_19").addClass("Schriftgröße_14");               
                break;
                case "2":
                  if(kontrastNumber == "true"){
                    $('#Gender').attr("style", "font-size: 15px; background-color: white !important; border-bottom: 1px dotted #1d5c87;");
                    $('#Zip').attr("style", "font-size: 15px; background-color: white !important; border-bottom: 1px dotted #1d5c87;");
                    $('#City').attr("style", "font-size: 15px; background-color: white !important; border-bottom: 1px dotted #1d5c87;");
                    $('#Street').attr("style", "font-size: 15px; background-color: white !important; border-bottom: 1px dotted #1d5c87;");
                    $('#HouseNumber').attr("style", "font-size: 15px; background-color: white !important; border-bottom: 1px dotted #1d5c87;");
                    $('#HouseNumberAddition').attr("style", "font-size: 15px; background-color: white !important; border-bottom: 1px dotted #1d5c87;");
                  } else{
                    $('#Gender').attr("style", "font-size: 15px;");
                    $('#Zip').attr("style", "font-size: 15px;");
                    $('#City').attr("style", "font-size: 15px;");
                    $('#Street').attr("style", "font-size: 15px;");
                    $('#HouseNumber').attr("style", "font-size: 15px;");
                    $('#HouseNumberAddition').attr("style", "font-size: 15px;");
                  }

                  $('#btoChoose').removeClass("btoChooseWidth100_0").addClass("btoChooseWidth100_0").removeClass("Schriftgröße_14").addClass("Schriftgröße_15");
                  $('.customerDataContainerEditButtonNoIconsAdditionalAddressEdit > div:nth-child(1) > div:nth-child(1) > table:nth-child(1) > tbody:nth-child(1) > tr:nth-child(1) > td:nth-child(2) > div:nth-child(1) > button:nth-child(1)').removeClass("Schriftgröße_14").addClass("Schriftgröße_15");      
                break;
                case "3":
                  if(kontrastNumber == "true"){
                    $('#Gender').attr("style", "font-size: 16px; background-color: white !important; border-bottom: 1px dotted #1d5c87;");
                    $('#Zip').attr("style", "font-size: 16px; background-color: white !important; border-bottom: 1px dotted #1d5c87;");
                    $('#City').attr("style", "font-size: 16px; background-color: white !important; border-bottom: 1px dotted #1d5c87;");
                    $('#Street').attr("style", "font-size: 16px; background-color: white !important; border-bottom: 1px dotted #1d5c87;");
                    $('#HouseNumber').attr("style", "font-size: 16px; background-color: white !important; border-bottom: 1px dotted #1d5c87;");
                    $('#HouseNumberAddition').attr("style", "font-size: 16px; background-color: white !important; border-bottom: 1px dotted #1d5c87;");
                  } else{
                    $('#Gender').attr("style", "font-size: 16px;");
                    $('#Zip').attr("style", "font-size: 16px;");
                    $('#City').attr("style", "font-size: 16px;");
                    $('#Street').attr("style", "font-size: 16px;");
                    $('#HouseNumber').attr("style", "font-size: 16px;");
                    $('#HouseNumberAddition').attr("style", "font-size: 16px;");
                  }

                  $('#btoChoose').removeClass("btoChooseWidth100_0").addClass("btoChooseWidth100_0").removeClass("Schriftgröße_15").addClass("Schriftgröße_16");
                  $('.customerDataContainerEditButtonNoIconsAdditionalAddressEdit > div:nth-child(1) > div:nth-child(1) > table:nth-child(1) > tbody:nth-child(1) > tr:nth-child(1) > td:nth-child(2) > div:nth-child(1) > button:nth-child(1)').removeClass("Schriftgröße_15").addClass("Schriftgröße_16");
                break;
                case "4":
                  if(kontrastNumber == "true"){
                    $('#Gender').attr("style", "font-size: 17px; background-color: white !important; border-bottom: 1px dotted #1d5c87;");
                    $('#Zip').attr("style", "font-size: 17px; background-color: white !important; border-bottom: 1px dotted #1d5c87;");
                    $('#City').attr("style", "font-size: 17px; background-color: white !important; border-bottom: 1px dotted #1d5c87;");
                    $('#Street').attr("style", "font-size: 17px; background-color: white !important; border-bottom: 1px dotted #1d5c87;");
                    $('#HouseNumber').attr("style", "font-size: 17px; background-color: white !important; border-bottom: 1px dotted #1d5c87;");
                    $('#HouseNumberAddition').attr("style", "font-size: 17px; background-color: white !important; border-bottom: 1px dotted #1d5c87;");
                  } else{
                    $('#Gender').attr("style", "font-size: 17px;");
                    $('#Zip').attr("style", "font-size: 17px;");
                    $('#City').attr("style", "font-size: 17px;");
                    $('#Street').attr("style", "font-size: 17px;");
                    $('#HouseNumber').attr("style", "font-size: 17px;");
                    $('#HouseNumberAddition').attr("style", "font-size: 17px;");
                  }

                  $('#btoChoose').removeClass("btoChooseWidth100_0").addClass("btoChooseWidth100_40").removeClass("Schriftgröße_16").addClass("Schriftgröße_17");
                  $('.customerDataContainerEditButtonNoIconsAdditionalAddressEdit > div:nth-child(1) > div:nth-child(1) > table:nth-child(1) > tbody:nth-child(1) > tr:nth-child(1) > td:nth-child(2) > div:nth-child(1) > button:nth-child(1)').removeClass("Schriftgröße_16").addClass("Schriftgröße_17");
                break;
                case "5":
                  if(kontrastNumber == "true"){
                    $('#Gender').attr("style", "font-size: 18px; background-color: white !important; border-bottom: 1px dotted #1d5c87;");
                    $('#Zip').attr("style", "font-size: 18px; background-color: white !important; border-bottom: 1px dotted #1d5c87;");
                    $('#City').attr("style", "font-size: 18px; background-color: white !important; border-bottom: 1px dotted #1d5c87;");
                    $('#Street').attr("style", "font-size: 18px; background-color: white !important; border-bottom: 1px dotted #1d5c87;");
                    $('#HouseNumber').attr("style", "font-size: 18px; background-color: white !important; border-bottom: 1px dotted #1d5c87;");
                    $('#HouseNumberAddition').attr("style", "font-size: 18px; background-color: white !important; border-bottom: 1px dotted #1d5c87;");
                  } else{
                    $('#Gender').attr("style", "font-size: 18px;");
                    $('#Zip').attr("style", "font-size: 18px;");
                    $('#City').attr("style", "font-size: 18px;");
                    $('#Street').attr("style", "font-size: 18px;");
                    $('#HouseNumber').attr("style", "font-size: 18px;");
                    $('#HouseNumberAddition').attr("style", "font-size: 18px;");
                  }

                  $('#btoChoose').removeClass("btoChooseWidth100_40").addClass("btoChooseWidth100_40").removeClass("Schriftgröße_17").addClass("Schriftgröße_18");
                  $('.customerDataContainerEditButtonNoIconsAdditionalAddressEdit > div:nth-child(1) > div:nth-child(1) > table:nth-child(1) > tbody:nth-child(1) > tr:nth-child(1) > td:nth-child(2) > div:nth-child(1) > button:nth-child(1)').removeClass("Schriftgröße_17").addClass("Schriftgröße_18");
                break;
              }
        }
    };

    render()
    {     
        let maxValue = moment();

        let gender = '';
        let birth = '';
        let street = '';
        let name = '';
        let firstName = '';
        let adressAddition = '';
        let zip = '';
        let city = '';
        let houseNumber = '';
        let houseNumberAddition = '';
        let phone = '';
        let email = '';
        
        gender = (<TextField 
          AppURL={Vas.ApplicationUrl} 
          Editable={false} 
          Id={"Gender"} 
          ref={"gender"} 
          Label={Vas.Resources.Labels["Gender"]}  
        />);
        birth = (<TextField 
          AppURL={Vas.ApplicationUrl} 
          Editable={false} 
          Id={"DateOfBirth"} 
          ref={"dateOfBirth"} 
          Label={Vas.Resources.Labels["DateOfBirth"]} 
        />);
        street = (<AutocompleteField 
          AppURL={Vas.ApplicationUrl} 
          TitleMessageFalseStreet={Vas.Resources.Labels["Error"]} 
          MessageFalseStreet={Vas.Resources.Labels["FalseStreet"]}  
          Modus={"Street"} 
          ref={"street"} 
          Id={"Street"} 
          Float={'left'} 
          editable={false} 
          Label={Vas.Resources.Labels["Street"]} 
          Data={this.StreetsModel.Streets} 
          OnBlur={()=>{ this.AdditionalAddressesModel.Address.Street = $("#Street").val() ; }} 
          Tooltip={Vas.Resources.Tooltips["Street"]} 
          TimeOutTime={Vas.TimeOutTime}
          IsRequired={true}
        />);
        name = (<TextField 
          AppURL={Vas.ApplicationUrl} 
          ref={"name"} 
          Editable={false} 
          Id={"Name1"} 
          Label={Vas.Resources.Labels["Name"]} 
          OnBlur={()=>{
            if ($("#Name1").val().length === 0){$("#Name1").val(this.AdditionalAddressesModel.Address.Name1);} else {this.AdditionalAddressesModel.Address.Name1 = $("#Name1").val();}
          }}
          Modus={"Name"} 
          IsRequired={true}
        />);
        firstName = (<TextField 
          AppURL={Vas.ApplicationUrl} 
          ref={"firstName"} 
          Editable={false} 
          Id={"Name2"} 
          Label={Vas.Resources.Labels["FirstName"]} 
          OnBlur={()=>{if ($("#Name2").val().length === 0){$("#Name2").val(this.AdditionalAddressesModel.Address.Name2);} else {this.AdditionalAddressesModel.Address.Name2 = $("#Name2").val(); }}}
          Modus={"Name"}
          IsRequired={true}
        />);
        adressAddition = (<TextField 
          AppURL={Vas.ApplicationUrl} 
          ref={"adressAddition"} 
          Editable={false} 
          Id={"AddressAddition"} 
          Label={Vas.Resources.Labels["AdditionAdress"]} 
          OnChange={()=>{ this.AdditionalAddressesModel.Address.Name3 = $("#AddressAddition").val(); }}
        />);
        zip = (<TextField 
          AppURL={Vas.ApplicationUrl} 
          ref={"zip"} 
          Id={"Zip"} 
          Label={Vas.Resources.Labels["Zip"]} 
          Editable={false} 
          OnBlur={()=>{if ($("#Zip").val().length < 5 && $("#Zip").val().length >= 0){
            $("#Zip").val(this.AdditionalAddressesModel.Address.Zip);
            ReactDOM.render(<MessageBox 
              Message={Vas.Resources.Labels["PLZNote"]} 
              Title={Vas.Resources.Titles["Note"]} />
                ,document.getElementById('messageContainer'));
          } else {
            this.AdditionalAddressesModel.Address.Zip = $("#Zip").val();this.getStreets();
          }
        }}
          Modus={"Number"}
          IsRequired={true}
        />);
        city = (<TextField 
          AppURL={Vas.ApplicationUrl} 
          ref={"city"} 
          Id={"City"} 
          Label={Vas.Resources.Labels["Place"]} 
          Editable={false} 
          OnChange={()=>{if ($("#City").val().length < 0)
                        {$("#City").val(this.AdditionalAddressesModel.Address.City);} 
                        else {this.AdditionalAddressesModel.Address.City = $("#City").val();this.getStreets();}}}
          IsRequired={true}
          />);
        houseNumber = (<TextField 
          AppURL={Vas.ApplicationUrl} 
          ref={"houseNumber"} 
          Id={"HouseNumber"} 
          Editable={false} 
          Label={Vas.Resources.Labels["HouseNumber"]} 
          OnBlur={()=>{if ($("#HouseNumber").val().length === 0){$("#HouseNumber").val(this.AdditionalAddressesModel.Address.HouseNumber);} else {this.AdditionalAddressesModel.Address.HouseNumber = $("#HouseNumber").val();}}}
          Modus={"Number"}
          IsRequired={true}
        />);
        houseNumberAddition = (<TextField 
          AppURL={Vas.ApplicationUrl} 
          ref={"houseNumberAddition"} 
          Id={"HouseNumberAddition"} 
          Editable={false} 
          Label={Vas.Resources.Labels["HouseNumberAddition"]} 
          OnChange={()=>{ this.AdditionalAddressesModel.Address.HouseNumberAddition = $("#HouseNumberAddition").val(); }}
          Modus={"Char"}
        />);

        phone = (<TextField 
          AppURL={Vas.ApplicationUrl} 
          ref={"phone"} 
          Editable={false} 
          Id={"Phone"} 
          Label={Vas.Resources.Labels["Phone"]} 
          OnBlur={()=>{
            if ($("#Phone").val().length === 0){$("#Phone").val(this.AdditionalAddressesModel.Address.Phone);} else {this.AdditionalAddressesModel.Address.Phone = $("#Phone").val();}
          }}
          Modus={"Phone"} 
          IsRequired={false}
        />);

        email = (<TextField 
          AppURL={Vas.ApplicationUrl} 
          Id={"Email"} 
          ref={"email"} 
          Label={Vas.Resources.Labels["Email"]} 
          IsRequired={false}
          OnBlur={()=>{
            if ($("#Email").val().length === 0){$("#Email").val(this.AdditionalAddressesModel.Address.Email);} else {this.AdditionalAddressesModel.Address.Email = $("#Email").val();}
          }}
          />);

        if (this.state.Edit === true){

         
            gender = (<SelectField 
              AppURL={Vas.ApplicationUrl} 
              ref={"gender"} 
              IsRequired={true} 
              Id={"Gender"} 
              Default={this.AdditionalAddressesModel.Address.Gender} 
              Label={Vas.Resources.Labels["Gender"]} 
              Data={ this.state.GenderValues } 
              OnChange={()=>{
                if(document.getElementById('Gender').selectedIndex > 0){
                  this.AdditionalAddressesModel.Address.Gender = TranslateGender.Translate($("#Gender").val(),localStorage.getItem('vas_language'));
                }
              }}
              Tooltip={Vas.Resources.Tooltips["Gender"]} 
              Selected={false} 
              Picker={false}
               />);
        }  

        let classNameEditForm = "customerDataContainerEditButton";
        if(this.IconConfig.ShowIcons === false){
          if (this.state.Edit === true){ 
            classNameEditForm = "customerDataContainerEditButtonNoIconsAdditionalAddressEdit";
          }else{
            classNameEditForm = "customerDataContainerEditButtonNoIconsAdditionalAddress";
          }
           
        }

        return (
        
          <div style={{ marginTop:10, marginLeft:10 }}>

              <div>
                <div className={"customerCardSubTitle"}><b>{Vas.Resources.Labels["AdditionalAddress"]}</b></div>
                <div className={classNameEditForm}>
                  <EditFormButton 
                  ref={"EditFormButton"} 
                  base={this} 
                  curr={this.state} 
                  id={this.props.id} 
                  ShowIcons={this.IconConfig.ShowIcons}/>
                </div>
              </div>
              <div className={"customerDataContainer"}>
              
                <div className={"customerDataContainerLarge"}>
                  <TextField 
                  AppURL={Vas.ApplicationUrl} 
                  Editable={false} 
                  Id={"Salutation"} 
                  ref={"Salutation"} 
                  Label={Vas.Resources.Labels["Salutation"]} 
                  Value={this.state.Salutation} /> 
                </div>
                
              </div>
              <div className={"customerDataContainer"}>
                <div className={"customerDataContainerLarge"}>{name}</div>
                <div className={"customerDataContainerSmall"}>{firstName}</div>
              </div>
              <div className={"customerDataContainer"}>
                <div className={"customerDataContainerLarge"}>{birth}</div>
                <div className={"customerDataContainerSmall"}>{gender}</div>
              </div>
              <div className={"customerDataContainer"}>
                <div className={"customerDataContainerLarge"}>{zip}</div>
                <div className={"customerDataContainerSmall"}>{city}</div>
              </div>
              <div className={"customerDataContainer"}>
                  <div className={"customerDataContainerLarge"}>{street}</div>
              </div>
              <div className={"customerDataContainer"}>
                  <div className={"customerDataContainerLarge"}>{houseNumber}</div>
                  <div className={"customerDataContainerSmall"}>{houseNumberAddition}</div>
              </div>
              <div className={"customerDataContainer"}>
                  <div className={"customerDataContainerLarge"}>{adressAddition}</div>
              </div>
              
              <div className={"customerDataContainer"}>
                  <div className={"customerDataContainerLarge"}>{phone}</div>
                  
              </div>
              <div className={"customerDataContainer"}>
                <div className={"customerDataContainerLarge"}>
                  {email}
                </div>
              </div>
          </div>
        );
    }
}
export default CustomerAddressDetails;
